import {createSlice} from '@reduxjs/toolkit';
import {REDUCERS_NAMES} from '../constants';
import {DrugItem} from 'store/types';

interface stateType {
  value: DrugItem[];
  willNeedRefetch: boolean;
}

const initialState: {drugs: stateType} = {
  drugs: {
    value: [],
    willNeedRefetch: true, // you will need to make this true ,when u need to refetch the data
  },
};

export const drugsSlice = createSlice({
  name: REDUCERS_NAMES.DRUGS,
  initialState,
  reducers: {
    setDrugsList: (state, action: {payload: stateType; type: string}) => {
      state.drugs.value = action.payload.value ?? state.drugs.value;
      state.drugs.willNeedRefetch =
        action.payload.willNeedRefetch ?? state.drugs.willNeedRefetch;
    },
  },
});

export const {setDrugsList} = drugsSlice.actions;

export default drugsSlice.reducer;
